<template>
  <Card back>
    <template v-slot:header>
      <h4 class="d-inline">پرداخت هزینه ها</h4>
      <hr />
    </template>
    <template v-slot:content>
      <div class="mx-4" :id="$route.name">
        <div v-if="showRowState">
          <i class="fas Pointer fa-plus text-success h4" @click="changeState(1)"></i>
        </div>

        <div v-else>
          <i class="fas Pointer fa-times text-danger h4" @click="changeState(0)"></i>
        </div>

        <!-- ------------------------------------------------------- -->

        <!-- <Show :propsRows="propsRows" @ChangeState="changeStateFromShow" @Result="result()" /> -->
        <div v-if="showRowState" class="row mt-2">
          <div class="col-md-3 col-12 mt-2">
            <small>از تاریخ </small>
            <date-picker color="dimgray" input-class="required form-control" v-model="Filter.tarixAz" clearable :editable="true" placeholder=" از تاریخ "></date-picker>
          </div>
          <div class="col-md-3 col-12 mt-2">
            <small>تا تاریخ </small>
            <date-picker color="dimgray" input-class="required form-control" v-model="Filter.tarixTa" clearable :editable="true" placeholder=" تا تاریخ "></date-picker>
          </div>
          <div class="col-md-2 col-12 mt-4">
            <button type="button" class="btn btn-success w-100 mt-1" @click="getPropsRows"><i class="fad fa-search mt-1 ml-2"></i> اعمال فیلتر</button>
          </div>
        </div>
        <div v-if="showRowState">
          <BnpGrid :key="renderkey" :action="true" :propsRows="Rows" :propsColumn="propsColumn" :NoRowNum="true" :Noresposive="true">
            <template slot="filePath" slot-scope="props">
              <div v-if="props.props.filePath != null">
                <a :href="url + props.props.filePath" class="text-success" target="_blank">دارد</a>
              </div>
              <div v-else>
                <p class="text-danger">ندارد</p>
              </div>
            </template>
            <template slot="amount" slot-scope="props">
             {{ $Comma3ragham(props.props.amount) }}
            </template>

            <template slot="for" slot-scope="props">
              <span :data-title="props.props.for" v-if="props.props.for != null"> {{ props.props.for.slice(0, 40) + (props.props.for.length > 40 ? '...' : '') }}</span>
            </template>

            <template slot="action-slot" slot-scope="props">
              <request-info :RequestRow="props.props" @Success="getPropsRows" @DataEdit="DataEdit" :ApiAction="'CostPermission'" :IsDelete="true" :IsEdit="true" :FormAutomation="ControlName"></request-info>
            </template>
          </BnpGrid>
        </div>

        <Add
          v-if="addRowState"
          :EditMode="Isedit"
          :EditRow="editItem"
          :DataFormProps="true"
          @Result="
            getPropsRows()
            addRowState = false
            showRowState = true
          "
        />

        <!-- <Edit v-if="editRowState" :item="editItem" @Result="result()" /> -->
      </div>
    </template>
  </Card>
</template>

<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import Add from './Components/Add.vue'
import RequestInfo from '@/components/AutomAtion/RequestInfo.vue'
import datePicker from 'vue-persian-datetime-picker'

export default {
  components: { Card, BnpGrid, SearchableCombo, Add, RequestInfo,datePicker },
  data() {
    return {
      Isedit: false,
      renderkey: 0,
      Rows: [],
      propsColumn: [
        { name: 'dateTimeInsert', label: 'زمان ایجاد', visibility: true },
        { name: 'costSubject', label: 'موضوع', visibility: true },
        { name: 'amount', label: 'مبلغ', visibility: true },
        { name: 'for', label: 'توضیحات', visibility: true },
        { name: 'filePath', label: 'پیوست', visibility: true },
        { name: 'namFam', label: 'ایجاد کننده', visibility: true },
      ],
      showRowState: true,
      addRowState: false,
      editItem: {},
      addUserItem: {},
      Filter: { tblUserId: this.$session.get('UserInfo').tblUserId, tarixTa: '', tarixAz: '' },
      ControlName:""
    }
  },

  methods: {
    changeState(state) {
      if (state == 0) {
        this.showRowState = true
        this.addRowState = false
        this.editRowState = false
      }
      if (state == 1) {
        this.Isedit = false
        this.showRowState = false
        this.addRowState = true
        this.editRowState = false
      }
      if (state == 2) {
        this.showRowState = false
        this.addRowState = false
        this.editRowState = true
      }
    },
    changeStateFromShow(state) {
      if (state.state == 2) {
        this.editItem = state.item
      }
      this.changeState(state.state)
    },
    getPropsRows() {
      let DataAxios_SetData = {
        ArryfildValue: this.Filter,
        Method: 'POST',
        Action: 'CostPermission/GetData',
        Token: this.$session.get('Token'),
      }
      this.$PostData(DataAxios_SetData)
        .then((data) => {
          this.Rows = data
          this.tableKey++
        })
        .catch((err) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی در خواندن اطلاعات', 'error', 2000)
        })
        .finally(() => {
          this.renderkey++
        })
    },
    DataEdit(row) {
      this.addRowState = true
      this.showRowState = false
      this.editItem = row
      this.Isedit = true
    },
    GetFormAutomationId(){
      this.$FindTableNameOnAutomationCartabl(5).then((res) => {
             this.ControlName= res
            })
    }
  },
  created() {
    this.GetFormAutomationId()
    this.Filter.tarixAz=this.$GetFirstAndLastDayOfMonth().SDate;
    this.Filter.tarixTa=this.$GetFirstAndLastDayOfMonth().EDate;
    this.getPropsRows()
    if (this.rowForEdit) {
      this.$store.state.OldDataForLog = this.rowForEdit
      this.Isedit = true
      this.editItem=JSON.parse(this.rowForEdit)
      this.addRowState = true
      this.showRowState = false
    }
  },
  props: ['rowForEdit'],
}
</script>
